// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════════════════
   SwitchPortsTab — Inline port grid + editor
   Embedded inside the detail form Puertos tab.
   ═══════════════════════════════════════════════════════════════════════════ */

/* ── Container ── */
.spt-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Loading / Empty ── */
.spt-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 40px 0;
  justify-content: center;
  color: var(--text-muted);
  font-size: 14px;
}

.spt-empty {
  text-align: center;
  padding: 40px 0;
  color: var(--text-muted);
  font-size: 14px;
}

.spt-empty p { margin: 8px 0 0; }

/* ── Stats bar ── */
.spt-stats {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 10px 16px;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: 10px;
  flex-wrap: wrap;
}

.spt-stat {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--text-secondary);
}

.spt-stat strong {
  color: var(--text-primary);
  font-size: 15px;
}

.spt-stat-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

.spt-dot--connected { background: var(--port-connected-dot); }
.spt-dot--uplink    { background: var(--port-uplink-dot); }
.spt-dot--free      { background: var(--slate-200); }

.spt-legend {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 14px;
}

.spt-legend-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: var(--text-muted);
}

.spt-leg-swatch {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  display: inline-block;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

/* ── Toolbar buttons + add/bulk panels ── */
.spt-toolbar-btn {
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.spt-toolbar-btn:hover {
  background: var(--bg-input);
  color: var(--text-primary);
}

.spt-toolbar-btn.active {
  border-color: var(--accent);
  background: rgba(var(--accent-rgb), 0.16);
  color: var(--accent-l);
}

.spt-panel {
  border-radius: 10px;
  padding: 0.75rem 1rem;
  margin-bottom: 0.75rem;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
}

.spt-panel--accent {
  background: rgba(var(--accent-rgb), 0.08);
  border-color: rgba(var(--accent-rgb), 0.35);
}

.spt-panel--bulk {
  background: var(--bg-toolbar);
  border-color: var(--accent-2);
}

.spt-panel--success {
  background: var(--green-50);
  border: 1px solid rgba(16, 185, 129, 0.4);
}

.spt-panel-title {
  font-weight: 700;
  font-size: 0.82rem;
  margin-bottom: 8px;
  color: var(--accent-l);
}

.spt-panel--bulk .spt-panel-title { color: var(--accent-2); }
.spt-panel--success .spt-panel-title { color: var(--green-600); }

.spt-panel-label {
  font-size: 0.72rem;
  color: var(--text-muted);
  margin-bottom: 2px;
}

.spt-panel-hint {
  font-size: 0.78rem;
  color: var(--text-muted);
}

.spt-panel-error {
  color: var(--red-600);
  font-size: 0.78rem;
  margin-top: 6px;
}

.spt-panel-ok {
  color: var(--green-600);
  font-size: 0.78rem;
  margin-top: 6px;
}

.spt-field {
  padding: 4px 8px;
  border: 1px solid var(--border);
  border-radius: 6px;
  font-size: 0.82rem;
  background: var(--bg-input);
  color: var(--text-primary);
}

.spt-field:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 2px rgba(var(--accent-rgb), 0.15);
}

.spt-btn-primary,
.spt-btn-success {
  padding: 5px 14px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 700;
  font-size: 0.82rem;
  color: #fff;
}

.spt-btn-primary { background: var(--accent); }
.spt-btn-primary:hover:not(:disabled) { background: var(--accent-dark); }

.spt-btn-bulk { background: var(--accent-2); }
.spt-btn-bulk:hover:not(:disabled) { filter: brightness(1.12); }

.spt-btn-success { background: var(--green-600); }
.spt-btn-success:hover:not(:disabled) { filter: brightness(1.1); }

.spt-btn-primary:disabled,
.spt-btn-success:disabled { opacity: 0.6; cursor: not-allowed; }

.spt-btn-secondary {
  padding: 5px 10px;
  border-radius: 6px;
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  cursor: pointer;
  font-size: 0.82rem;
}

.spt-btn-secondary:hover {
  background: var(--bg-input);
  color: var(--text-primary);
}

/* ── Port grid section ── */
.spt-grid-section {
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px 20px;
}

.spt-grid-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.spt-grid-hint {
  font-weight: 400;
  color: var(--text-muted);
  font-size: 12px;
}

.spt-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.spt-row {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}

/* ── Port card buttons ── */
.spt-port {
  width: 52px;
  height: 52px;
  border: 2px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: transform 0.12s, box-shadow 0.12s;
  position: relative;
  padding: 2px;
  gap: 1px;
}

.spt-port:hover {
  transform: scale(1.12);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  z-index: 1;
}

/* Port state colours */
.spt-port--outlet {
  background: var(--spt-outlet-bg);
  color: var(--spt-outlet-fg);
  border-color: var(--spt-outlet-bd);
}

.spt-port--connected {
  background: var(--spt-connected-bg);
  color: var(--spt-connected-fg);
}

.spt-port--uplink {
  background: var(--spt-uplink-bg);
  color: var(--spt-uplink-fg);
}

.spt-port--free {
  background: var(--slate-200);
  color: var(--spt-free-fg);
}

.spt-port--inactive {
  background: var(--spt-inactive-bg);
  color: var(--spt-inactive-fg);
  opacity: 0.6;
}

.spt-port--empty {
  background: repeating-linear-gradient(
    45deg,
    var(--spt-empty-bg1, #f1f5f9),
    var(--spt-empty-bg1, #f1f5f9) 4px,
    var(--spt-empty-bg2, #e2e8f0) 4px,
    var(--spt-empty-bg2, #e2e8f0) 8px
  );
  color: var(--text-muted);
  border-color: var(--slate-300);
  opacity: 0.75;
  cursor: default;
}

.spt-dot--empty {
  background: var(--spt-empty-bg2, #e2e8f0);
  border: 1px dashed var(--text-muted) !important;
}

.spt-port--mirror {
  background: var(--spt-mirror-bg);
  color: #ffffff;
  border-color: var(--spt-mirror-bd);
}

.spt-dot--mirror {
  background: var(--spt-mirror-bg);
}

.spt-port--selected {
  border-color: var(--accent) !important;
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.25) !important;
  transform: scale(1.1);
  z-index: 2;
}

/* Wall outlet cable indicator dot */
.spt-port-wall-dot {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--accent-2);
  border: 1.5px solid #fff;
  pointer-events: none;
  flex-shrink: 0;
}

.spt-port-num {
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.spt-port-dest {
  font-size: 8px;
  line-height: 1;
  max-width: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: 0.85;
}

.spt-port-speed {
  font-size: 7px;
  line-height: 1;
  opacity: 0.7;
  letter-spacing: -0.02em;
}

/* VLAN del puerto (access NNN / trunk …) — resumen compacto en la casilla */
.spt-port-vlan {
  position: absolute;
  bottom: 1px;
  left: 1px;
  font-size: 6px;
  font-weight: 700;
  line-height: 1;
  padding: 1px 3px;
  border-radius: 3px;
  background: var(--spt-vlan-bg, #0284c7);
  color: var(--spt-vlan-fg, #ffffff);
  letter-spacing: 0.02em;
  pointer-events: none;
}

.spt-port-vlan--trunk {
  background: var(--spt-vlan-trunk-bg, #7c3aed);
}

.spt-port-connector-badge {
  font-size: 6px;
  font-weight: 700;
  line-height: 1;
  padding: 1px 3px;
  border-radius: 2px;
  letter-spacing: 0.03em;
  max-width: 46px;
  white-space: nowrap;
}

/* ── Inline port editor ── */
.spt-editor {
  background: var(--editor-bg);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.spt-editor-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
  font-size: 14px;
  color: var(--text-primary);
  flex-wrap: wrap;
}

.spt-editor-num strong {
  font-size: 16px;
}

.spt-editor-label {
  color: var(--text-muted);
}

.spt-editor-badge {
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.spt-badge--on {
  background: var(--badge-on-bg);
  color: var(--badge-on-fg);
}

.spt-badge--off {
  background: var(--badge-off-bg);
  color: var(--badge-off-fg);
}

.spt-editor-close {
  margin-left: auto;
  background: none;
  border: 1px solid var(--border);
  border-radius: 6px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  font-size: 13px;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  flex-shrink: 0;
}

.spt-editor-close:hover {
  background: var(--error-bg);
  border-color: var(--error-bd);
  color: var(--error-text);
}

/* ── Connection banner ── */
.spt-conn-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--conn-banner-bg);
  border: 1px solid var(--conn-banner-bd);
  border-radius: 8px;
  padding: 10px 12px;
  gap: 10px;
  flex-wrap: wrap;
}

.spt-conn-path {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  flex: 1 1;
  min-width: 0;
}

.spt-conn-arrow {
  color: var(--conn-arrow);
  font-size: 1rem;
  flex-shrink: 0;
}

.spt-conn-cable {
  color: var(--conn-cable-text);
  font-size: 0.8125rem;
  font-family: monospace;
}

.spt-conn-color {
  font-size: 0.8125rem;
  color: var(--text-muted);
}

.spt-disconnect-btn {
  background: var(--bg-card);
  color: var(--error-text);
  border: 1px solid var(--error-bd);
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8125rem;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.12s;
}

.spt-disconnect-btn:hover:not(:disabled) {
  background: var(--error-bg);
}

.spt-disconnect-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Wall outlet banner (panel ports only) ── */
.spt-wall-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--wall-banner-bg);
  border: 1px solid var(--wall-banner-bd);
  border-radius: 8px;
  padding: 8px 12px;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 4px;
}

.spt-wall-arrow {
  color: var(--accent-2);
  font-size: 0.9rem;
}

.spt-wall-hint {
  font-size: 0.72rem;
  color: var(--accent-2);
  white-space: nowrap;
  flex-shrink: 0;
}

.spt-wall-empty {
  padding: 7px 12px;
  font-size: 0.78rem;
  color: var(--wall-accent);
  background: var(--wall-banner-bg);
  border: 1px dashed var(--wall-banner-bd);
  border-radius: 8px;
  margin-top: 4px;
}

/* ── Form fields ── */
.spt-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.spt-field label {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.spt-fields-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
}

/* Destination toggle */
.spt-dest-toggle {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.spt-toggle-btn {
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 7px 14px;
  font-size: 13px;
  cursor: pointer;
  color: var(--text-secondary);
  transition: all 0.15s;
  white-space: nowrap;
}

.spt-toggle-btn.active {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
  font-weight: 600;
}

.spt-toggle-btn:hover:not(.active) {
  background: var(--slate-200);
}

/* Inputs */
.spt-input {
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 14px;
  color: var(--text-primary);
  transition: border-color 0.15s, box-shadow 0.15s;
  width: 100%;
  box-sizing: border-box;
}

.spt-input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.1);
}

.spt-select {
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 14px;
  color: var(--text-primary);
  background: var(--bg-input);
  cursor: pointer;
  width: 100%;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.spt-select:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.1);
}

/* Títulos de grupo dentro del desplegable nativo.
   Se usan <option disabled> en vez de <optgroup>: en Windows/Edge el fondo
   del optgroup se pinta blanco y rompe el tema oscuro. */
.spt-select option.spt-select-group {
  background: var(--bg-surface);
  color: var(--text-secondary);
  font-weight: 600;
}

.spt-select option:disabled:not(.spt-select-group) {
  color: var(--text-muted);
}

/* Filtro de alcance del selector de destinos. */
.spt-scope-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0 8px;
  font-size: 0.8125rem;
  color: var(--text-secondary);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.spt-scope-toggle input {
  accent-color: var(--accent);
  cursor: pointer;
}

.spt-scope-toggle em {
  margin-left: auto;
  font-style: normal;
  color: var(--text-muted);
}

.spt-hint {
  font-size: 0.8125rem;
  color: var(--text-muted);
  font-style: italic;
}

/* Error */
.spt-error {
  background: var(--error-bg);
  border: 1px solid var(--error-bd);
  border-radius: 8px;
  padding: 9px 14px;
  font-size: 13px;
  color: var(--error-text);
}

/* Actions */
.spt-editor-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 8px;
  border-top: 1px solid var(--border);
}

.spt-btn-cancel {
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}

.spt-btn-cancel:hover {
  background: var(--slate-200);
}

.spt-btn-save {
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.spt-btn-save:hover:not(:disabled) {
  background: var(--accent-dark);
}

.spt-btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ── Responsive ── */
@media (max-width: 700px) {
  .spt-fields-grid {
    grid-template-columns: 1fr 1fr;
  }
  .spt-legend {
    display: none;
  }
  .spt-port {
    width: 42px;
    height: 42px;
  }
}

@media (max-width: 480px) {
  .spt-fields-grid {
    grid-template-columns: 1fr;
  }
  .spt-port {
    width: 38px;
    height: 38px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SwitchPortsTab.css"],"names":[],"mappings":"AAAA;;;gFAGgF;;AAEhF,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA,eAAe,eAAe,EAAE;;AAEhC,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,sBAAsB,qCAAqC,EAAE;AAC7D,sBAAsB,kCAAkC,EAAE;AAC1D,sBAAsB,4BAA4B,EAAE;;AAEpD;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,oCAAoC,sBAAsB,EAAE;AAC5D,uCAAuC,uBAAuB,EAAE;;AAEhE;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA,mBAAmB,yBAAyB,EAAE;AAC9C,wCAAwC,8BAA8B,EAAE;;AAExE,gBAAgB,2BAA2B,EAAE;AAC7C,qCAAqC,wBAAwB,EAAE;;AAE/D,mBAAmB,4BAA4B,EAAE;AACjD,wCAAwC,uBAAuB,EAAE;;AAEjE;4BAC4B,YAAY,EAAE,mBAAmB,EAAE;;AAE/D;EACE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE;;;;;;GAMC;EACD,wBAAwB;EACxB,8BAA8B;EAC9B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,8DAA8D;EAC9D,qBAAqB;EACrB,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,uBAAuB;AACzB;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,kCAAkC;EAClC,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,sCAAsC;EACtC,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;EACjC,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,gDAAgD;EAChD,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;;yDAEyD;AACzD;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE;IACE,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════════════════════════\r\n   SwitchPortsTab — Inline port grid + editor\r\n   Embedded inside the detail form Puertos tab.\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n\r\n/* ── Container ── */\r\n.spt-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n/* ── Loading / Empty ── */\r\n.spt-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 40px 0;\r\n  justify-content: center;\r\n  color: var(--text-muted);\r\n  font-size: 14px;\r\n}\r\n\r\n.spt-empty {\r\n  text-align: center;\r\n  padding: 40px 0;\r\n  color: var(--text-muted);\r\n  font-size: 14px;\r\n}\r\n\r\n.spt-empty p { margin: 8px 0 0; }\r\n\r\n/* ── Stats bar ── */\r\n.spt-stats {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 18px;\r\n  padding: 10px 16px;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.spt-stat {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 13px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.spt-stat strong {\r\n  color: var(--text-primary);\r\n  font-size: 15px;\r\n}\r\n\r\n.spt-stat-dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.spt-dot--connected { background: var(--port-connected-dot); }\r\n.spt-dot--uplink    { background: var(--port-uplink-dot); }\r\n.spt-dot--free      { background: var(--slate-200); }\r\n\r\n.spt-legend {\r\n  margin-left: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n}\r\n\r\n.spt-legend-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-size: 12px;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.spt-leg-swatch {\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 3px;\r\n  display: inline-block;\r\n  border: 1px solid rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n/* ── Toolbar buttons + add/bulk panels ── */\r\n.spt-toolbar-btn {\r\n  padding: 3px 10px;\r\n  border-radius: 6px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\r\n}\r\n\r\n.spt-toolbar-btn:hover {\r\n  background: var(--bg-input);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.spt-toolbar-btn.active {\r\n  border-color: var(--accent);\r\n  background: rgba(var(--accent-rgb), 0.16);\r\n  color: var(--accent-l);\r\n}\r\n\r\n.spt-panel {\r\n  border-radius: 10px;\r\n  padding: 0.75rem 1rem;\r\n  margin-bottom: 0.75rem;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n}\r\n\r\n.spt-panel--accent {\r\n  background: rgba(var(--accent-rgb), 0.08);\r\n  border-color: rgba(var(--accent-rgb), 0.35);\r\n}\r\n\r\n.spt-panel--bulk {\r\n  background: var(--bg-toolbar);\r\n  border-color: var(--accent-2);\r\n}\r\n\r\n.spt-panel--success {\r\n  background: var(--green-50);\r\n  border: 1px solid rgba(16, 185, 129, 0.4);\r\n}\r\n\r\n.spt-panel-title {\r\n  font-weight: 700;\r\n  font-size: 0.82rem;\r\n  margin-bottom: 8px;\r\n  color: var(--accent-l);\r\n}\r\n\r\n.spt-panel--bulk .spt-panel-title { color: var(--accent-2); }\r\n.spt-panel--success .spt-panel-title { color: var(--green-600); }\r\n\r\n.spt-panel-label {\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.spt-panel-hint {\r\n  font-size: 0.78rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.spt-panel-error {\r\n  color: var(--red-600);\r\n  font-size: 0.78rem;\r\n  margin-top: 6px;\r\n}\r\n\r\n.spt-panel-ok {\r\n  color: var(--green-600);\r\n  font-size: 0.78rem;\r\n  margin-top: 6px;\r\n}\r\n\r\n.spt-field {\r\n  padding: 4px 8px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 6px;\r\n  font-size: 0.82rem;\r\n  background: var(--bg-input);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.spt-field:focus {\r\n  outline: none;\r\n  border-color: var(--accent);\r\n  box-shadow: 0 0 0 2px rgba(var(--accent-rgb), 0.15);\r\n}\r\n\r\n.spt-btn-primary,\r\n.spt-btn-success {\r\n  padding: 5px 14px;\r\n  border-radius: 6px;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-weight: 700;\r\n  font-size: 0.82rem;\r\n  color: #fff;\r\n}\r\n\r\n.spt-btn-primary { background: var(--accent); }\r\n.spt-btn-primary:hover:not(:disabled) { background: var(--accent-dark); }\r\n\r\n.spt-btn-bulk { background: var(--accent-2); }\r\n.spt-btn-bulk:hover:not(:disabled) { filter: brightness(1.12); }\r\n\r\n.spt-btn-success { background: var(--green-600); }\r\n.spt-btn-success:hover:not(:disabled) { filter: brightness(1.1); }\r\n\r\n.spt-btn-primary:disabled,\r\n.spt-btn-success:disabled { opacity: 0.6; cursor: not-allowed; }\r\n\r\n.spt-btn-secondary {\r\n  padding: 5px 10px;\r\n  border-radius: 6px;\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  border: 1px solid var(--border);\r\n  cursor: pointer;\r\n  font-size: 0.82rem;\r\n}\r\n\r\n.spt-btn-secondary:hover {\r\n  background: var(--bg-input);\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* ── Port grid section ── */\r\n.spt-grid-section {\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 16px 20px;\r\n}\r\n\r\n.spt-grid-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 14px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.spt-grid-hint {\r\n  font-weight: 400;\r\n  color: var(--text-muted);\r\n  font-size: 12px;\r\n}\r\n\r\n.spt-grid {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.spt-row {\r\n  display: flex;\r\n  gap: 5px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* ── Port card buttons ── */\r\n.spt-port {\r\n  width: 52px;\r\n  height: 52px;\r\n  border: 2px solid rgba(0, 0, 0, 0.08);\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: transform 0.12s, box-shadow 0.12s;\r\n  position: relative;\r\n  padding: 2px;\r\n  gap: 1px;\r\n}\r\n\r\n.spt-port:hover {\r\n  transform: scale(1.12);\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);\r\n  z-index: 1;\r\n}\r\n\r\n/* Port state colours */\r\n.spt-port--outlet {\r\n  background: var(--spt-outlet-bg);\r\n  color: var(--spt-outlet-fg);\r\n  border-color: var(--spt-outlet-bd);\r\n}\r\n\r\n.spt-port--connected {\r\n  background: var(--spt-connected-bg);\r\n  color: var(--spt-connected-fg);\r\n}\r\n\r\n.spt-port--uplink {\r\n  background: var(--spt-uplink-bg);\r\n  color: var(--spt-uplink-fg);\r\n}\r\n\r\n.spt-port--free {\r\n  background: var(--slate-200);\r\n  color: var(--spt-free-fg);\r\n}\r\n\r\n.spt-port--inactive {\r\n  background: var(--spt-inactive-bg);\r\n  color: var(--spt-inactive-fg);\r\n  opacity: 0.6;\r\n}\r\n\r\n.spt-port--empty {\r\n  background: repeating-linear-gradient(\r\n    45deg,\r\n    var(--spt-empty-bg1, #f1f5f9),\r\n    var(--spt-empty-bg1, #f1f5f9) 4px,\r\n    var(--spt-empty-bg2, #e2e8f0) 4px,\r\n    var(--spt-empty-bg2, #e2e8f0) 8px\r\n  );\r\n  color: var(--text-muted);\r\n  border-color: var(--slate-300);\r\n  opacity: 0.75;\r\n  cursor: default;\r\n}\r\n\r\n.spt-dot--empty {\r\n  background: var(--spt-empty-bg2, #e2e8f0);\r\n  border: 1px dashed var(--text-muted) !important;\r\n}\r\n\r\n.spt-port--mirror {\r\n  background: var(--spt-mirror-bg);\r\n  color: #ffffff;\r\n  border-color: var(--spt-mirror-bd);\r\n}\r\n\r\n.spt-dot--mirror {\r\n  background: var(--spt-mirror-bg);\r\n}\r\n\r\n.spt-port--selected {\r\n  border-color: var(--accent) !important;\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.25) !important;\r\n  transform: scale(1.1);\r\n  z-index: 2;\r\n}\r\n\r\n/* Wall outlet cable indicator dot */\r\n.spt-port-wall-dot {\r\n  position: absolute;\r\n  top: 3px;\r\n  right: 3px;\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: var(--accent-2);\r\n  border: 1.5px solid #fff;\r\n  pointer-events: none;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.spt-port-num {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n}\r\n\r\n.spt-port-dest {\r\n  font-size: 8px;\r\n  line-height: 1;\r\n  max-width: 44px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  opacity: 0.85;\r\n}\r\n\r\n.spt-port-speed {\r\n  font-size: 7px;\r\n  line-height: 1;\r\n  opacity: 0.7;\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n/* VLAN del puerto (access NNN / trunk …) — resumen compacto en la casilla */\r\n.spt-port-vlan {\r\n  position: absolute;\r\n  bottom: 1px;\r\n  left: 1px;\r\n  font-size: 6px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  padding: 1px 3px;\r\n  border-radius: 3px;\r\n  background: var(--spt-vlan-bg, #0284c7);\r\n  color: var(--spt-vlan-fg, #ffffff);\r\n  letter-spacing: 0.02em;\r\n  pointer-events: none;\r\n}\r\n\r\n.spt-port-vlan--trunk {\r\n  background: var(--spt-vlan-trunk-bg, #7c3aed);\r\n}\r\n\r\n.spt-port-connector-badge {\r\n  font-size: 6px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  padding: 1px 3px;\r\n  border-radius: 2px;\r\n  letter-spacing: 0.03em;\r\n  max-width: 46px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ── Inline port editor ── */\r\n.spt-editor {\r\n  background: var(--editor-bg);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.spt-editor-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding-bottom: 12px;\r\n  border-bottom: 1px solid var(--border);\r\n  font-size: 14px;\r\n  color: var(--text-primary);\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.spt-editor-num strong {\r\n  font-size: 16px;\r\n}\r\n\r\n.spt-editor-label {\r\n  color: var(--text-muted);\r\n}\r\n\r\n.spt-editor-badge {\r\n  padding: 3px 10px;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.spt-badge--on {\r\n  background: var(--badge-on-bg);\r\n  color: var(--badge-on-fg);\r\n}\r\n\r\n.spt-badge--off {\r\n  background: var(--badge-off-bg);\r\n  color: var(--badge-off-fg);\r\n}\r\n\r\n.spt-editor-close {\r\n  margin-left: auto;\r\n  background: none;\r\n  border: 1px solid var(--border);\r\n  border-radius: 6px;\r\n  width: 28px;\r\n  height: 28px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  color: var(--text-muted);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.15s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.spt-editor-close:hover {\r\n  background: var(--error-bg);\r\n  border-color: var(--error-bd);\r\n  color: var(--error-text);\r\n}\r\n\r\n/* ── Connection banner ── */\r\n.spt-conn-banner {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background: var(--conn-banner-bg);\r\n  border: 1px solid var(--conn-banner-bd);\r\n  border-radius: 8px;\r\n  padding: 10px 12px;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.spt-conn-path {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 0.875rem;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.spt-conn-arrow {\r\n  color: var(--conn-arrow);\r\n  font-size: 1rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.spt-conn-cable {\r\n  color: var(--conn-cable-text);\r\n  font-size: 0.8125rem;\r\n  font-family: monospace;\r\n}\r\n\r\n.spt-conn-color {\r\n  font-size: 0.8125rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.spt-disconnect-btn {\r\n  background: var(--bg-card);\r\n  color: var(--error-text);\r\n  border: 1px solid var(--error-bd);\r\n  border-radius: 6px;\r\n  padding: 5px 10px;\r\n  font-size: 0.8125rem;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n  transition: background 0.12s;\r\n}\r\n\r\n.spt-disconnect-btn:hover:not(:disabled) {\r\n  background: var(--error-bg);\r\n}\r\n\r\n.spt-disconnect-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* ── Wall outlet banner (panel ports only) ── */\r\n.spt-wall-banner {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background: var(--wall-banner-bg);\r\n  border: 1px solid var(--wall-banner-bd);\r\n  border-radius: 8px;\r\n  padding: 8px 12px;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  margin-top: 4px;\r\n}\r\n\r\n.spt-wall-arrow {\r\n  color: var(--accent-2);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.spt-wall-hint {\r\n  font-size: 0.72rem;\r\n  color: var(--accent-2);\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.spt-wall-empty {\r\n  padding: 7px 12px;\r\n  font-size: 0.78rem;\r\n  color: var(--wall-accent);\r\n  background: var(--wall-banner-bg);\r\n  border: 1px dashed var(--wall-banner-bd);\r\n  border-radius: 8px;\r\n  margin-top: 4px;\r\n}\r\n\r\n/* ── Form fields ── */\r\n.spt-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.spt-field label {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: var(--text-muted);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n}\r\n\r\n.spt-fields-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr;\r\n  gap: 12px;\r\n}\r\n\r\n/* Destination toggle */\r\n.spt-dest-toggle {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.spt-toggle-btn {\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  padding: 7px 14px;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  transition: all 0.15s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.spt-toggle-btn.active {\r\n  background: var(--accent);\r\n  border-color: var(--accent);\r\n  color: #fff;\r\n  font-weight: 600;\r\n}\r\n\r\n.spt-toggle-btn:hover:not(.active) {\r\n  background: var(--slate-200);\r\n}\r\n\r\n/* Inputs */\r\n.spt-input {\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  padding: 9px 12px;\r\n  font-size: 14px;\r\n  color: var(--text-primary);\r\n  transition: border-color 0.15s, box-shadow 0.15s;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.spt-input:focus {\r\n  outline: none;\r\n  border-color: var(--accent);\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.1);\r\n}\r\n\r\n.spt-select {\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  padding: 9px 12px;\r\n  font-size: 14px;\r\n  color: var(--text-primary);\r\n  background: var(--bg-input);\r\n  cursor: pointer;\r\n  width: 100%;\r\n  transition: border-color 0.15s, box-shadow 0.15s;\r\n}\r\n\r\n.spt-select:focus {\r\n  outline: none;\r\n  border-color: var(--accent);\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.1);\r\n}\r\n\r\n/* Títulos de grupo dentro del desplegable nativo.\r\n   Se usan <option disabled> en vez de <optgroup>: en Windows/Edge el fondo\r\n   del optgroup se pinta blanco y rompe el tema oscuro. */\r\n.spt-select option.spt-select-group {\r\n  background: var(--bg-surface);\r\n  color: var(--text-secondary);\r\n  font-weight: 600;\r\n}\r\n\r\n.spt-select option:disabled:not(.spt-select-group) {\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* Filtro de alcance del selector de destinos. */\r\n.spt-scope-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin: 4px 0 8px;\r\n  font-size: 0.8125rem;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.spt-scope-toggle input {\r\n  accent-color: var(--accent);\r\n  cursor: pointer;\r\n}\r\n\r\n.spt-scope-toggle em {\r\n  margin-left: auto;\r\n  font-style: normal;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.spt-hint {\r\n  font-size: 0.8125rem;\r\n  color: var(--text-muted);\r\n  font-style: italic;\r\n}\r\n\r\n/* Error */\r\n.spt-error {\r\n  background: var(--error-bg);\r\n  border: 1px solid var(--error-bd);\r\n  border-radius: 8px;\r\n  padding: 9px 14px;\r\n  font-size: 13px;\r\n  color: var(--error-text);\r\n}\r\n\r\n/* Actions */\r\n.spt-editor-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n  padding-top: 8px;\r\n  border-top: 1px solid var(--border);\r\n}\r\n\r\n.spt-btn-cancel {\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  padding: 10px 20px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.spt-btn-cancel:hover {\r\n  background: var(--slate-200);\r\n}\r\n\r\n.spt-btn-save {\r\n  background: var(--accent);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 10px 24px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.spt-btn-save:hover:not(:disabled) {\r\n  background: var(--accent-dark);\r\n}\r\n\r\n.spt-btn-save:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* ── Responsive ── */\r\n@media (max-width: 700px) {\r\n  .spt-fields-grid {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n  .spt-legend {\r\n    display: none;\r\n  }\r\n  .spt-port {\r\n    width: 42px;\r\n    height: 42px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .spt-fields-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .spt-port {\r\n    width: 38px;\r\n    height: 38px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
